// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/attitude-flying.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/attitude-flying/attitude-flying.js';

mount([g0]);
